// Utils
import { cloneDeep, map } from 'lodash';

// Constants
import { ItemTableConsts, LocalStorageConsts } from 'client/util/Constants';
import LocalStorageService from 'client/util/LocalStorageService';
import SystemUserItemTableColumns, { mainPanelColumnOptions } from 'client/systemusers/SystemUserItemTable/SystemUserItemTableColumns';

const localStorageKey = LocalStorageConsts.systemUserMainPanelColumns;

/**
 * Mixin for User State
 */
export default {
  LocalStorageService,
  localStorageKey,

  computed: {

    // List of default columns for Devices Aside
    devicesSystemUserDefaultColumns() {
      return [
        SystemUserItemTableColumns.state,
        SystemUserItemTableColumns.name,
        this.getPasswordStatus,
        SystemUserItemTableColumns.mfaTotpStatus,
        SystemUserItemTableColumns.sudoStatus,
      ];
    },

    getPasswordStatus() {
      const { passwordStatus } = SystemUserItemTableColumns;
      const classNames = ItemTableConsts.columnTypes.passwordStatusColumn;
      const heading = 'Password Status';

      passwordStatus.bodyComponent = 'PasswordStatusIcon';
      passwordStatus.classNames.body = [classNames];
      passwordStatus.classNames.heading = [classNames];
      passwordStatus.headingText = heading;
      passwordStatus.name = heading;
      passwordStatus.sortBy = 'status password_expiration_date';

      return passwordStatus;
    },

    // List of default columns for Ldap Aside
    ldapSystemUserDefaultColumns() {
      return [
        SystemUserItemTableColumns.state,
        SystemUserItemTableColumns.name,
        SystemUserItemTableColumns.email,
        SystemUserItemTableColumns.bindStatus,
      ];
    },

    // List of default and required columns for SystemUserItemTable
    systemUserDefaultColumns() {
      return [
        SystemUserItemTableColumns.state,
        SystemUserItemTableColumns.name,
        SystemUserItemTableColumns.email,
      ];
    },

    systemUserRequiredFields() {
      return [
        SystemUserItemTableColumns.state.name,
        SystemUserItemTableColumns.name.name,
      ];
    },

    systemUserSudoColumns() {
      return [
        SystemUserItemTableColumns.globalAdminSudo,
      ];
    },

    systemUserPasswordlessSudoColumns() {
      return [
        SystemUserItemTableColumns.globalAdminSudo,
        SystemUserItemTableColumns.globalPasswordlessSudo,
      ];
    },

    // List of default columns for main Users page
    usersMainPanelDefaultColumns() {
      return [
        SystemUserItemTableColumns.state,
        SystemUserItemTableColumns.name,
        SystemUserItemTableColumns.email,
        this.getPasswordStatus,
        SystemUserItemTableColumns.mfaTotpStatus,
      ];
    },

    usersMainPanelColumnOptions() {
      return cloneDeep(mainPanelColumnOptions);
    },
  },

  methods: {
    getIndexOfArchivedColumnInLocalStorage() {
      const storedColumnNames = this.$options.LocalStorageService.getItem(
        this.$options.localStorageKey,
      ) || '';
      const columnArray = storedColumnNames.split(',');
      const archivedColumnName = 'TOTP MFA Status';

      return columnArray.indexOf(archivedColumnName);
    },

    getIsNewColumnAlreadyIncluded(columns) {
      const existingColumnNames = map(columns, 'name');

      return existingColumnNames.includes(SystemUserItemTableColumns.mfaTotpStatus.name);
    },

    getUpdatedColumns(columnsToUpdate, indexOfArchivedColumn) {
      return [
        ...columnsToUpdate.slice(0, indexOfArchivedColumn),
        SystemUserItemTableColumns.mfaTotpStatus,
        ...columnsToUpdate.slice(indexOfArchivedColumn),
      ];
    },

    /*
     *The columns to update will come in with the archived column filtered out
     *This is done in columnsToDisplay computed property in MainPanelWithItemTableMixin.js
     *The methods here ensure the archived column is replaced with the appropriate new column
     *Method added on 2022-04-07 and can be safely removed after 2022-07-01
    */
    replaceArchivedMfaColumns(columnsToUpdate) {
      const indexOfArchivedColumn = this.getIndexOfArchivedColumnInLocalStorage();
      const isArchivedColumnInLocalStorage = indexOfArchivedColumn !== -1;
      const isNewColumnAlreadyIncluded = this.getIsNewColumnAlreadyIncluded(columnsToUpdate);

      // add new mfa column if it is not included and the old column is in Local Storage
      const shouldUpdateColumns = !isNewColumnAlreadyIncluded
        && isArchivedColumnInLocalStorage;
      const updatedColumns = shouldUpdateColumns
        ? this.getUpdatedColumns(columnsToUpdate, indexOfArchivedColumn)
        : columnsToUpdate;

      if (isArchivedColumnInLocalStorage) {
        const updatedColumnNames = map(updatedColumns, 'name');
        this.$options.LocalStorageService.setItem(
          this.$options.localStorageKey, updatedColumnNames,
        );
      }

      return updatedColumns;
    },
  },
};
